import * as React from "react";
import {
  Button,
  Typography,
  Box,
  TextField,
  Modal,
  Autocomplete,
} from "@mui/material";
import { createEffect } from "effector";
import api from "../../Auth/api";
import { useStore } from "effector-react";
import { $userSearch, searchUserFx } from "../../Api/userSearch";
import { getServicePageFx } from "../../Api/PaidService/servicePage";
import { useForm } from "react-hook-form";
import debounce from "lodash/debounce";
import { updateModal } from "../ErrorModal";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "1px solid #000",
  boxShadow: 2,
  p: 2,
};

export default function ServiceModal({ task, isCanceled = false }) {
  const usersTable = useStore($userSearch);
  const [open, setOpen] = React.useState(false);
  const [responsible, setResponsible] = React.useState();
  const [departmentName, setDepartmentName] = React.useState("");
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const searchUser = React.useCallback(
    debounce((_, value) => {
      searchUserFx(value);
    }, 200),
    []
  );
  const onUpdateFormSubmit = () => {
    updateTypeTaskFx({
      id: task.id,
      newResponsibleUserIds: responsible.map((r) => r.id),
    });
  };
  const handleCloseModal = () => setOpen(false);
  const handleOpenModal = () => {
    setDepartmentName(task?.type?.name);
    setResponsible(task?.responsibleUsers || []);
    setOpen(true);
  };
  const updateTypeTaskFx = createEffect(async (data) => {
    api
      .post(`/paid-service/task-set-responsible-user-ids`, data)
      .then(null, (error) => updateModal(error.response.data.errors))
      .then(() => {
        handleCloseModal();
        getServicePageFx(task.paidServiceId);
      });
  });

  return (
    <>
      <Button onClick={handleOpenModal} size="small" disabled={isCanceled}>
        сменить
      </Button>
      <Modal
        open={open}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <form onSubmit={handleSubmit(onUpdateFormSubmit)}>
          <Box sx={style}>
            <Typography
              mb={3}
              id="modal-modal-title"
              variant="h6"
              fontWeight={600}
            >
              {departmentName}
            </Typography>
            <Box display="flex" alignItems="center" mb={2}></Box>
            <Box display="flex" flexDirection="row" alignItems="center" mt={2}>
              <Typography
                width={180}
                mb={1}
                variant="subtitle1"
                fontWeight={600}
              >
                Ответственные:
              </Typography>
              <Box width="260px">
                <Autocomplete
                  id="tags-standard"
                  options={usersTable}
                  value={responsible}
                  multiple
                  onInputChange={searchUser}
                  onChange={(_, value) => setResponsible(value)}
                  getOptionLabel={(option) => option?.name}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  renderInput={(params) => (
                    <TextField {...params} {...register("users")} />
                  )}
                />
                {errors.users && <span>Поле обязательно для заполнения</span>}
              </Box>
            </Box>
            <Box
              mt={3}
              width="100%"
              display="flex"
              gap={3}
              justifyContent="flex-end"
            >
              <Button variant="outlined" onClick={handleCloseModal}>
                Отмена
              </Button>
              <Button type="submit" variant="contained">
                Сохранить
              </Button>
            </Box>
          </Box>
        </form>
      </Modal>
    </>
  );
}
